// import external dependencies
import jQuery from 'jquery';
global.$ = global.jQuery = jQuery;

// import local dependencies
import Router from './util/router';
import common from './routes/common';
import home from './routes/home';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

(function($) {
  $('#toggle').click(function() {
   $(this).toggleClass('active');
   $('body').toggleClass('nav-open');
  });
})(jQuery);



// WEBPACK FOOTER //
// ./scripts/main.js